/* usePauseAdDismiss.tsx */
import AnalyticsInstance, { AnalyticEventType } from '@shared/utils/analytics';
import { PauseAd } from '@shared/types/interfaces/ads';
import { useEffect, useRef } from 'react';

export default function usePauseAdDismiss(pauseAd: PauseAd | undefined) {
  const wasActiveRef = useRef(false);

  useEffect(() => {
    if (pauseAd) {
      wasActiveRef.current = true;
    } else {
      if (wasActiveRef.current) {
        AnalyticsInstance.addEvent(AnalyticEventType.PAUSE_AD_DISMISS);
      }
      wasActiveRef.current = false;
    }
  }, [pauseAd]);
}
